const AbstractPayyoRequestRecord = require('./AbstractPayyoRequestRecord');

class PayyoMerchantRequestRecord extends AbstractPayyoRequestRecord {
    /**
     * A 35 character string beginning with mr_ which identifies a merchant in Payyo.
     *
     * @param {string} merchantId
     */
    constructor(merchantId) {
        const regex = /^mr_[a-zA-Z0-9]{32}$/g;
        if (!merchantId || !merchantId.match(regex)) {
            throw new Error('A valid merchantId is required');
        }
        super(
            'GET',
            'merchants/' + merchantId,
        );
    }
}

module.exports = PayyoMerchantRequestRecord;
